import { Theme } from '@material-ui/core';

export const styles = (theme: Theme) => ({
  select: {
    width: '100%',
    height: 45,
    backgroundColor: theme.customPalette.background.inputBg,
    '&.Mui-disabled': {
      opacity: 0.7,
      '& .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${theme.customPalette.borders.select}`,
      },
    },
    '& .MuiOutlinedInput-input': {
      background: 'none',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${theme.customPalette.borders.select}`,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${theme.customPalette.borders.select}`,
    },
    '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${theme.customPalette.borders.select}`,
    },
  },
  input: {
    color: theme.customPalette.text.primary,
  },
  menuItem: {
    color: theme.customPalette.text.primary,
    '&:hover': {
      background: theme.customPalette.background.inputBg,
    },
  },
  popover: {
    border: `1px solid ${theme.customPalette.borders.select}`,
    marginTop: 5,
  },
});
